const drivers = {
  table: {
    headers: {
      suppliers: 'Fleet',
    },
    filters: {
      suppliers: 'Fleet',
    },
  },

  forms: {
    information: {
      supplier: {
        header: 'Fleets',
        fields: {
          suppliers: 'Fleets',
        },
      },
    },
  },
};

export default drivers;
